import { render, staticRenderFns } from "./PermissionsCheckbox.vue?vue&type=template&id=017c34ee&scoped=true&"
import script from "./PermissionsCheckbox.vue?vue&type=script&lang=js&"
export * from "./PermissionsCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsCheckbox.vue?vue&type=style&index=0&id=017c34ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017c34ee",
  null
  
)

export default component.exports